@if (serviceScript) {
<mat-card appearance="outlined" class="view-orders-container">
  @if (jwtAuth.getIsDemoUserView() || manageShiftService.isActionDisabledForClinician()) {
  <div class="interaction-blocker"></div>
  }
  <mat-tab-group [(selectedIndex)]="tabIndex" disableRipple dynamicHeight>
    <mat-tab label="Order Details">
      <div class="example-large-box mat-elevation-z0">
        <mat-card appearance="outlined" class="mm-outlined order-details-inner">
          @if (!jwtAuth.isClinician()) {
          <app-order-progress-bar
            [currentStatus]="currentStatus"
            [paymentStatus]="serviceScript?.orderData.paymentstatus"
            [orderClass]="serviceScript?.orderData.order_class"
          ></app-order-progress-bar>
          }
          <mat-card appearance="outlined" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <div class="current-status" fxLayout="row" fxLayoutAlign="start center">
                <span>Current Status</span>
                <mat-icon class="current-status-arrow">arrow_forward_ios</mat-icon>
                <span class="mm-text-accent">
                  {{ getOrderStatusLabel(serviceScript?.orderData.orderstatus) }}</span
                >
                @if (isWeightLossFollowUpOrder()) {
                <span class="weight-loss-follow-up-badge mm-ml-2">
                  Weight Loss - Follow Up
                </span>
                }
              </div>
              <div class="uniqueorderid">#{{ serviceScript?.orderData.uniqueorderid }}</div>
            </div>
            @if (viewButtons()) {
            <div class="d-flex flex-wrap mm-gap-5 mm-ml-5">
              @if (showMoreActionsButton && !isDriverUser && !jwtAuth.isClinician()) {
              <button
                mat-flat-button
                class="mm-bg-grey-blue mm-text-white mm-mr-2"
                (click)="$event.stopPropagation(); moreActions()"
              >
                <span>More</span>
                <mat-icon iconPositionEnd class="mm-mb-1">keyboard_arrow_down</mat-icon>
              </button>
              } @if (jwtAuth.isAdmin() || !jwtAuth.isClinician()) {
              <a
                mat-flat-button
                color="accent"
                class="mm-text-white mm-mr-2"
                [href]="'tel:' + serviceScript.orderData.mobilenumber"
              >
                <mat-icon class="mm-mr-1">call</mat-icon>
                <span>Call Patient</span>
              </a>
              } @if (jwtAuth.isClinician() && !isOrderStatusAssigned()) {
              <button
                mat-flat-button
                color="primary"
                id="escalate-btn"
                class="mm-bg-primary mm-text-white mm-mr-2"
                (click)="outOfScopeDialog()"
                [disabled]="shiftOrderStatus === 'paused'"
              >
                Escalate
              </button>
              } @if (!isDriverUser && canShowPrintOrderButton()) {
              <button
                mat-flat-button
                color="accent"
                class="mm-text-white mm-mr-2"
                (click)="printOrder()"
              >
                <mat-icon class="mm-mr-1">print</mat-icon>
                <span>Print Order</span>
              </button>
              } @if (showMoreActions) {
              <ul class="vieworder-menu">
                @for (menuItem of menuItems; track menuItem) {
                <li
                  [ngClass]="{
                    'vieworder-sub-menu-trigger': menuItem.name === 'Change Status'
                  }"
                >
                  @if (menuItem.name !== 'Change Status') {
                  <button
                    mat-menu-item
                    (click)="menuItemAction(menuItem.name)"
                    [style]="{ color: menuItem.color }"
                    [class.reminder-menu-item]="
                      menuItem.name === 'Send Manual Reminder' &&
                      serviceScript.orderData.pending_booking_reminder_sent_at
                    "
                  >
                    <span>{{ menuItem.name }}</span>
                    @if (menuItem.name === 'Send Manual Reminder' &&
                    serviceScript.orderData.pending_booking_reminder_sent_at) {
                    <span class="reminder-sent-hint">
                      Last sent:
                      {{
                        serviceScript.orderData.pending_booking_reminder_sent_at
                          | convertToLocalTime : 'DD/MM/YYYY h:mm A'
                      }}
                    </span>
                    }
                  </button>
                  } @else { @if (menuItem.sub.length > 0) {
                  <button mat-menu-item>
                    <span>{{ menuItem.name }}</span>
                    <mat-icon style="color: rgb(41, 41, 41)">keyboard_arrow_right</mat-icon>
                  </button>
                  <ul class="vieworder-menu vieworder-sub-menu">
                    @for (subMenu of menuItem.sub; track subMenu) {
                    <li>
                      <button
                        mat-menu-item
                        (click)="
                          $event.stopPropagation();
                          changeStatus(subMenu);
                          showMoreActions = false
                        "
                      >
                        {{ getOrderStatusLabel(subMenu) }}
                      </button>
                    </li>
                    }
                  </ul>
                  } }
                </li>
                }
              </ul>
              } @if (CanShowRepeatOrderButton &&currentStatus==='Completed'&&!isDriverUser &&
              !jwtAuth.isClinician()) {
              <button
                mat-flat-button
                class="mm-bg-orange mm-text-white mm-mr-2"
                (click)="showReorderScriptDialog(reorderScripts, true)"
              >
                Repeat Order
              </button>
              } @if (showPrintLabelButton()) {
              <button
                mat-flat-button
                class="mm-bg-accent mm-text-white mm-mr-2"
                (click)="printOrderLabel()"
              >
                Print Label
              </button>
              } @if (showTopButton2() && !jwtAuth.isClinician()) {
              <button
                mat-flat-button
                class="mm-bg-orange mm-text-white mm-mr-2"
                (click)="editOrder()"
              >
                Edit Order
              </button>
              } @if (showRejectButton() && !jwtAuth.isClinician()) {
              <button
                mat-flat-button
                class="mm-bg-orange mm-text-white mm-mr-2"
                (click)="changeStatus('Reject')"
              >
                Reject
              </button>
              } @if (currentStatus=='In Transit'&&isDriverUser && !jwtAuth.isClinician()) {
              <button
                mat-flat-button
                class="mm-bg-orange mm-text-white mm-mr-2"
                (click)="changeStatus('Return')"
              >
                Return
              </button>
              } @if (showTopButton3()) {
              <button
                [matTooltip]="getProceedAction()"
                mat-flat-button
                class="mm-bg-green mm-text-white"
                (click)="proceed()"
                [ngClass]="getButtonClasses()"
                [disabled]="editshow === 1"
              >
                {{ getTopButtonText3() }}
              </button>
              } @if ( showAddPaymentMethodButton()) {
              <button
                mat-flat-button
                class="mm-bg-green mm-text-white"
                (click)="confirmManualPayment()"
              >
                Add Payment Method
              </button>
              } @if (jwtAuth.isClinician() && !isOrderStatusAssigned()) {
              <button
                mat-flat-button
                id="complete-order-btn"
                class="mm-bg-primary mm-text-white"
                (click)="completeAppointment()"
                [disabled]="shiftOrderStatus === 'paused'"
              >
                Complete
              </button>
              }
            </div>
            }
            @if (showEscalateToClinicButton() || (showOnlyProceedButton() && !jwtAuth.isTelehealthPharmacyUser()) || showDispenseButton() || showAddTrackingLinkButton()) {
            <div fxLayout="row" fxLayoutAlign="end center">
              @if (showEscalateToClinicButton()) {
              <button
                matTooltip="Add a pharmacy note and send back to the clinic"
                mat-flat-button
                class="mm-bg-orange mm-text-white mm-mr-2"
                [disabled]="loading"
                (click)="escalateToClinic()"
              >
                Escalate
              </button>
              } @if (showOnlyProceedButton() && !jwtAuth.isTelehealthPharmacyUser()) {
              <button
                matTooltip="Completed"
                mat-flat-button
                class="mm-bg-green mm-text-white"
                (click)="preChangeStatus('Completed')"
              >
                Proceed
              </button>
              } @if (showDispenseButton()) {
              <button
                mat-flat-button
                class="mm-bg-green mm-text-white"
                [disabled]="loading"
                (click)="dispense()"
              >
                Dispense
              </button>
              } @if (showAddTrackingLinkButton()) {
              <button
                mat-flat-button
                class="mm-bg-green mm-text-white"
                [disabled]="loading"
                (click)="addTrackingLinkAndComplete()"
              >
                Add Tracking Link
              </button>
              }
            </div>
            }
          </mat-card>
          <div>
            <mat-card appearance="outlined" class="view-items">
              <div [ngClass]="isDriverUser ? 'mm-flex' : 'mm-grid'">
                @for (viewItem of viewItems; track viewItem; let i = $index) { @if
                (shouldShowTile(viewItem)) {
                <div
                  class="tile-hold"
                  [ngClass]="getTileClasses(viewItem)"
                  [ngStyle]="getTileStyles(viewItem)"
                >
                  @if (viewItem.orderDetails) {
                  <div id="intersection-trigger">
                    <h1 class="mm-text-accent">{{ viewItem.text }}</h1>
                    <p>
                      <b>Date:</b>
                      {{
                        viewItem.orderDetails.date
                          | date
                            : 'dd/MM/yyyy h:mm
                            a'
                      }}
                    </p>
                    <p><b>From:</b> {{ viewItem.orderDetails.from }}</p>
                    @if (viewItem.orderDetails.external_reference_id) {
                    <p>
                      <b>External Reference ID:</b>
                      {{ viewItem.orderDetails.external_reference_id }}
                    </p>
                    } @if (subscription) {
                    <p>
                      <b>Subscription:</b>
                      <span class="mm-ml-1 mm-text-orange mm-fw-500">{{
                        subscription.name
                      }}</span>
                    </p>
                    } @if (subscription) {
                    <p>
                      <b>Subscription Cycle:</b>
                      <span class="mm-ml-1 mm-fw-500">{{ subscription.cycle_number }}</span>
                    </p>
                    }
                  </div>
                  @if (!jwtAuth.isClinician()) {
                  <p>
                    <b>Promo Code:</b>
                    @if (promoCode) {
                    <span> {{ promoCode }}</span>
                    } @if (promoCode==null||promoCode=='') {
                    <span class="mm-text-pink"> No promotion code applied</span>
                    }
                  </p>
                  } @if (openRecordLink) {
                  <a
                    [href]="openRecordLink"
                    target="_blank"
                    mat-flat-button
                    color="primary"
                    class="mm-mt-2"
                  >
                    Open Record
                  </a>
                  } @if (viewItem.orderDetails.bookingTime &&
                  viewItem.orderDetails.bookingTime.isValid()) {
                  <div>
                    <strong>Booking Time:</strong>&nbsp;
                    <span class="mm-text-accent mm-fw-500">{{
                      viewItem.orderDetails.bookingTime.format('lll')
                    }}</span>
                  </div>
                  } @if (viewItem.orderDetails.requestedDoctorName) {
                  <p>
                    <b>Requested Doctor:</b>
                    <span class="mm-ml-1 mm-text-accent mm-fw-500">{{
                      viewItem.orderDetails.requestedDoctorName
                    }}</span>
                  </p>
                  }
                  @if (jwtAuth.isClinician()) {
                  <p>
                    <b>Consult Type:</b>
                    <span class="mm-ml-1 mm-text-accent mm-fw-500">{{
                      serviceScript.orderData.video_consultation_link ? 'Video Consult' : 'Phone Consult'
                    }}</span>
                  </p>
                  @if (serviceScript.orderData.coviu_room) {
                  <p>
                    <b>Coviu Room:</b>
                    <span class="mm-ml-1 mm-text-accent mm-fw-500">{{ serviceScript.orderData.coviu_room }}</span>
                  </p>
                  }
                  } @else {
                  <div
                    class="video-consult-link-row"
                    [class.editing]="admin === '1' && editingVideoConsultationLink"
                  >
                    <b>Video Consultation Link</b>
                    @if (admin === '1' && editingVideoConsultationLink) {
                    <div class="video-consult-link-edit-panel">
                      <input
                        #videoConsultationLinkInput
                        type="url"
                        placeholder="https://..."
                        class="mm-text-input video-consult-link-input"
                        [formControl]="videoConsultationLink"
                        [disabled]="savingVideoConsultationLink"
                        (keydown.enter)="
                          videoConsultationLink.value &&
                            !videoConsultationLink.invalid &&
                            !savingVideoConsultationLink &&
                            saveVideoConsultationLink()
                        "
                        (keydown.escape)="cancelUpdateVideoConsultationLink()"
                      />
                      @if (videoConsultationLink.invalid && videoConsultationLink.dirty) {
                      <div class="mm-text-pink video-consult-link-error">
                        Enter a valid URL, e.g. https://meet.example.com/room
                      </div>
                      }
                      <div
                        fxLayout="row"
                        fxLayoutAlign="end center"
                        class="video-consult-link-actions"
                        fxLayoutGap="8px"
                      >
                        <button
                          mat-stroked-button
                          [disabled]="savingVideoConsultationLink"
                          (click)="cancelUpdateVideoConsultationLink()"
                        >
                          Cancel
                        </button>
                        <button
                          mat-flat-button
                          color="primary"
                          [disabled]="
                            savingVideoConsultationLink ||
                            videoConsultationLink.invalid ||
                            !videoConsultationLink.value
                          "
                          (click)="saveVideoConsultationLink()"
                        >
                          {{ savingVideoConsultationLink ? 'Saving...' : 'Save' }}
                        </button>
                      </div>
                    </div>
                    } @else {
                    <div
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      fxLayoutGap="4px"
                      class="video-consult-link-value-row"
                    >
                      @if (serviceScript.orderData.video_consultation_link) {
                      <a
                        [href]="serviceScript.orderData.video_consultation_link"
                        target="_blank"
                        rel="noopener"
                        class="mm-text-accent mm-fw-500 video-consult-link-value"
                        >{{ serviceScript.orderData.video_consultation_link }}</a
                      >
                      } @else {
                      <span class="video-consult-link-value">Not set</span>
                      } @if (admin === '1') {
                      <button
                        mat-icon-button
                        matTooltip="Edit link"
                        class="mm-edit-icon-btn video-consult-link-edit-btn"
                        (click)="
                          editingVideoConsultationLink = true;
                          focusVideoConsultationLinkInput()
                        "
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      } @if (admin === '1' && serviceScript.orderData.video_consultation_link)
                      {
                      <button
                        mat-icon-button
                        matTooltip="Delete link"
                        class="mm-edit-icon-btn video-consult-link-edit-btn video-consult-link-delete-btn"
                        [disabled]="savingVideoConsultationLink"
                        (click)="confirmDeleteVideoConsultationLink()"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                      }
                    </div>
                    }
                  </div>
                  }
                  } @if (viewItem.patientDetails) {
                  <div>
                    <h1 class="mm-text-accent">{{ viewItem.text }}</h1>
                    <p class="d-flex align-items-center mm-gap-1 m-0">
                      <strong>Patient Name:</strong> {{ viewItem.patientDetails.name }}
                      @if (jwtAuth.isClinician()) {
                      <button
                        mat-icon-button
                        (click)="copyPatientName(viewItem.patientDetails)"
                        aria-label="Copy Patient Name"
                      >
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      }
                    </p>
                    <p class="d-flex align-items-center mm-gap-1 m-0">
                      <strong>Mobile Number:</strong>
                      {{
                        jwtAuth.isClinician()
                          ? viewItem.patientDetails.maskedMobileNumber
                          : viewItem.patientDetails.mobile
                      }}
                      @if (jwtAuth.isClinician()) {
                      <button
                        mat-icon-button
                        (click)="copyPatientMobileNumber(viewItem.patientDetails)"
                      >
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      }
                    </p>
                    <p><strong>Date of Birth:</strong> {{ viewItem.patientDetails.dob }}</p>
                    <p><strong>Sex:</strong> {{ viewItem.patientDetails.sex }}</p>
                    <p>
                      <strong>Medicare or IHI Provided: </strong
                      >{{ viewItem.patientDetails?.medicare }}
                    </p>
                    <p>{{ viewItem.patientDetails?.address?.street_address || '' }}</p>
                    <p>
                      {{
                        viewItem.patientDetails?.address?.suburb
                          ? viewItem.patientDetails?.address?.suburb + ','
                          : ''
                      }}
                      {{ viewItem.patientDetails?.address?.postcode || '' }}
                    </p>
                  </div>
                  } @if (viewItem.customerDetails) {
                  <div>
                    <h1 class="mm-text-accent">{{ viewItem.text }}</h1>
                    <p>
                      {{ viewItem.customerDetails.firstName }}
                      {{ viewItem.customerDetails.lastName }}
                    </p>
                    <p>{{ viewItem.customerDetails.email }}</p>
                    <p>{{ viewItem.customerDetails.mobilenumber }}</p>
                    <p>{{ viewItem.customerDetails.addressLine1 || '' }}</p>
                    <p>{{ viewItem.customerDetails.addressLine2 || '' }}</p>
                    <p>
                      {{
                        viewItem.customerDetails.suburb
                          ? viewItem.customerDetails.suburb +
                            '
                    ,'
                          : ''
                      }}
                      {{
                        viewItem.customerDetails.state
                          ? viewItem.customerDetails.state +
                            '
                    ,'
                          : ''
                      }}
                      {{ viewItem.customerDetails.postcode || '' }}
                    </p>
                    @if (serviceScript.orderData.phoneCode && !jwtAuth.isClinician()) {
                    <p>
                      <b>Uber Code:&nbsp;</b>
                      <span>{{ serviceScript.orderData.phoneCode }}</span>
                    </p>
                    } @if (serviceScript.orderData.MembershipNumber && !jwtAuth.isClinician())
                    {
                    <p>
                      <span class="mm-text-accent">Member No.&nbsp;</span>
                      <span>{{ serviceScript.orderData.MembershipNumber }}</span>
                    </p>
                    }
                    <p>
                      @if (!jwtAuth.isClinician()) {
                      <span class="mm-text-accent mm-text-bold">Type:&nbsp;</span>
                      }
                      <!-- <span *ngIf="serviceScript.orderData.ordertype==='Pick Up' || serviceScript.orderData.ordertype==='Pickup'">Pick Up</span> -->
                      @if (serviceScript.orderData.deliverypartnername) {
                      <span>{{ serviceScript.orderData.deliverypartnername }}</span>
                      }
                    </p>
                    @if (serviceScript.orderData.ordertype=='Delivery') {
                    <p>
                      <span class="mm-text-accent mm-text-bold"
                        >Delivery Instructions:&nbsp;</span
                      >
                      <span>{{ d_i }}</span>
                    </p>
                    }
                    <div
                      class="delivery-tracking-link-row"
                      [class.editing]="
                        canEditDeliveryTrackingLink() && editingDeliveryTrackingLink
                      "
                    >
                      <b>Delivery Tracking Link</b>
                      @if (canEditDeliveryTrackingLink() && editingDeliveryTrackingLink) {
                      <div class="delivery-tracking-link-edit-panel">
                        <input
                          #deliveryTrackingLinkInput
                          type="url"
                          placeholder="https://..."
                          class="mm-text-input delivery-tracking-link-input"
                          [formControl]="deliveryTrackingLink"
                          [disabled]="savingDeliveryTrackingLink"
                          (keydown.enter)="
                            deliveryTrackingLink.value &&
                              !deliveryTrackingLink.invalid &&
                              !savingDeliveryTrackingLink &&
                              saveDeliveryTrackingLink()
                          "
                          (keydown.escape)="cancelUpdateDeliveryTrackingLink()"
                          (paste)="onDeliveryTrackingLinkPaste($event)"
                        />
                        @if (deliveryTrackingLink.invalid && deliveryTrackingLink.dirty) {
                        <div class="mm-text-pink delivery-tracking-link-error">
                          {{
                            deliveryTrackingLink.errors?.ausPostSearchUrl
                              ? 'Enter the customer tracking code.'
                              : 'Enter a valid URL, e.g. https://track.example.com/abc123'
                          }}
                        </div>
                        }
                        <div
                          fxLayout="row"
                          fxLayoutAlign="end center"
                          class="delivery-tracking-link-actions"
                          fxLayoutGap="8px"
                        >
                          <button
                            mat-stroked-button
                            [disabled]="savingDeliveryTrackingLink"
                            (click)="cancelUpdateDeliveryTrackingLink()"
                          >
                            Cancel
                          </button>
                          <button
                            mat-flat-button
                            color="primary"
                            [disabled]="
                              savingDeliveryTrackingLink ||
                              deliveryTrackingLink.invalid ||
                              !deliveryTrackingLink.value
                            "
                            (click)="saveDeliveryTrackingLink()"
                          >
                            {{ savingDeliveryTrackingLink ? 'Saving...' : 'Save' }}
                          </button>
                        </div>
                      </div>
                      } @else {
                      <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="4px"
                        class="delivery-tracking-link-value-row"
                      >
                        @if (serviceScript.orderData.delivery_tracking) {
                        <a
                          [href]="serviceScript.orderData.delivery_tracking"
                          target="_blank"
                          rel="noopener"
                          class="mm-text-accent mm-fw-500 delivery-tracking-link-value"
                          >{{ serviceScript.orderData.delivery_tracking }}</a
                        >
                        } @else {
                        <span class="delivery-tracking-link-value">Not set</span>
                        } @if (canEditDeliveryTrackingLink()) {
                        <button
                          mat-icon-button
                          matTooltip="Edit tracking link"
                          class="mm-edit-icon-btn delivery-tracking-link-edit-btn"
                          (click)="
                            editingDeliveryTrackingLink = true;
                            focusDeliveryTrackingLinkInput()
                          "
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                        } @if (canEditDeliveryTrackingLink() &&
                        serviceScript.orderData.delivery_tracking) {
                        <button
                          mat-icon-button
                          matTooltip="Delete tracking link"
                          class="mm-edit-icon-btn delivery-tracking-link-edit-btn delivery-tracking-link-delete-btn"
                          [disabled]="savingDeliveryTrackingLink"
                          (click)="confirmDeleteDeliveryTrackingLink()"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                        }
                      </div>
                      }
                    </div>
                  </div>
                  } @if (viewItem.senderDetails) {
                  <div>
                    <h1 class="mm-text-accent">
                      <span>{{ viewItem.text }}</span
                      >@if (admin === '1') {
                      <span
                        class="mm-ml-2"
                        [ngClass]="{
                          'mm-text-green': serviceScript.orderData.locationstatus == 1,
                          'mm-text-pink': serviceScript.orderData.locationstatus == 2
                        }"
                        >({{ getPartnerStatus(serviceScript.orderData.locationstatus) }})</span
                      >
                      }
                    </h1>
                    <p>{{ viewItem.senderDetails.locationname }}</p>
                    <p>{{ viewItem.senderDetails.phone }}</p>
                    <p>{{ viewItem.senderDetails.address }}</p>
                    @if (viewItem.senderDetails.locationname == 'Huru') {
                    <p>
                      <span class="mm-text-accent mm-text-bold">Referred: &nbsp;</span>
                      <span>{{ surveyData.header.referred_by }}</span>
                    </p>
                    }
                    <p class="mb-3">{{ viewItem.senderDetails.times }}</p>
                  </div>
                  } @if (viewItem.pharmInstruction) {
                  <div>
                    <h1 class="mm-text-accent">{{ viewItem.text }}</h1>
                    <!-- <p>{{viewItem.pharmInstruction.pickupinstructions}}</p> -->
                    <div class="mb-6">
                      <p style="font-weight: 200">
                        {{
                          serviceScript.orderData.speakwithpharmacist == 1
                            ? 'Customer needs
                    to
                    speak with pharmacist'
                            : 'Customer does not need to speak with
                    pharmacist'
                        }}
                      </p>
                    </div>
                    <div class="mb-6">
                      <p class="mm-text-accent">Allergies</p>
                      <p class="mm-text-pink mat-subtitle-2">
                        {{
                          viewItem.pharmInstruction.anyallergies
                            ? viewItem.pharmInstruction.anyallergies
                            : 'No
                  allergies'
                        }}
                      </p>
                    </div>
                  </div>
                  } @if (viewItem.pharmacyOrderNotes) {
                  <h1 class="mm-text-accent">{{ viewItem.text }}</h1>
                  <div class="pharmacy-notes-hold">
                    <textarea
                      [placeholder]="'Interact with ' + serviceScript.orderData.locationname"
                      (focus)="showConfirmPharmacyNotes = true"
                      (blur)="showConfirmPharmacyNotes = false"
                      spellcheck="false"
                      [formControl]="pharmacyOrderNotes"
                      class="pharmacy-notes-input custom-scroll-bar"
                    >
                    </textarea>
                    @if (showConfirmPharmacyNotes == true) {
                    <div class="confirm-notes-hold pharmacy-notes">
                      <button
                        class="confirm-note-button"
                        (mousedown)="
                          $event.stopPropagation(); _updateOrderNotes('pharmacyOrderNotes')
                        "
                      >
                        <mat-icon>check</mat-icon>
                      </button>
                      <button
                        class="confirm-note-button mm-ml-2"
                        (mousedown)="cancelUpdateOrderNotes('pharmacyOrderNotes')"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                    }
                  </div>
                  } @if (viewItem.additionalDeliveryInstructions) {
                  <div class="order-notes-container" id="additionalDeliveryInstructions">
                    <h1 class="mm-text-accent">{{ viewItem.text }}</h1>
                    <div class="mb-6">
                      @if (viewItem.additionalDeliveryInstructions) {
                      <div class="order-notes">
                        {{ viewItem.additionalDeliveryInstructions }}
                      </div>
                      }
                    </div>
                    @if (canShowEditDeliveryInstructionsButton()) {
                    <button
                      mat-flat-button
                      class="mm-bg-grey-blue mm-text-white mm-mr-2"
                      (click)="openDeliveryDetailsDialog()"
                    >
                      Edit Delivery Instructions
                    </button>
                    }
                  </div>
                  } @if (viewItem.orderInstructions) {
                  <div class="order-notes-container">
                    <h1 class="mm-text-accent">{{ viewItem.text }}</h1>
                    <div class="order-notes-inner no-scroll-bar">
                      <div class="order-notes">
                        {{ viewItem.orderInstructions.orderInstructions }}
                      </div>
                      <div class="more-notes-overlay"></div>
                    </div>
                  </div>
                  } @if (viewItem.orderRemarks) {
                  <div class="order-notes-container">
                    <h1 class="mm-text-accent">{{ viewItem.text }}</h1>
                    <div class="order-notes-inner no-scroll-bar">
                      <div class="order-notes">{{ viewItem.orderRemarks.remarks }}</div>
                    </div>
                  </div>
                  } @if (viewItem.ClinicianDetails) {
                  <div class="order-notes-container">
                    <h1 class="mm-text-accent mm-mb-4">{{ viewItem.text }}</h1>
                    <div fxLayout="column" fxLayoutGap="12px">
                      <!-- Checkbox for selecting from all doctors -->
                      <mat-checkbox
                        [(ngModel)]="selectFromAllDoctors"
                        (change)="onSelectFromAllDoctorsChange()"
                        class="mm-mb-2"
                      >
                        Select from all clinicians:
                      </mat-checkbox>
                      <div fxLayout="row wrap" fxLayoutGap="16px" fxLayoutAlign="start center">
                        <app-clinician-select
                          [selectedClinician]="selectedClinician"
                          [clinicians]="filteredClinicians"
                          [assignedClinician]="assignedClincian"
                          [orderAssignStatus]="consultStatus"
                          [hideStats]="selectFromAllDoctors"
                          [showUnassignOverride]="false"
                          (clinicianChange)="onClinicianChange($event)"
                        >
                        </app-clinician-select>
                        <!--consult status drop down -->
                        <mat-form-field appearance="outline">
                          <mat-label>Consult Status</mat-label>
                          <mat-select
                            [(ngModel)]="selectedStatus"
                            (selectionChange)="changeConsultStatus($event.value)"
                            [disabled]="!selectedClinician"
                          >
                            @for (status of orderStatusOptions; track status) {
                            <mat-option [value]="status.value">
                              {{ status.display }}
                            </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  }
                </div>
                } }
              </div>
              <div class="notes-hold">
                @if (admin === '1') {
                <div class="pharmacy-instructions">
                  <div
                    fxLayout="column"
                    fxLayoutAlign="start center"
                    class="inner"
                    [ngClass]="{ editing: showConfirmCurrentOwner }"
                  >
                    <div class="notes-inner-container" fxLayout="column">
                      <div class="notes-header">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                          <div fxLayout="column">
                            <span>Current Owner</span>
                            <span style="font-size: 12px">Owner notes history</span>
                          </div>
                          @if (showConfirmCurrentOwner == true) {
                          <div>
                            <button
                              class="confirm-note-button mm-ml-2"
                              (mousedown)="cancelUpdateOrderNotes('currentOwner')"
                            >
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                          }
                        </div>
                      </div>
                      <div class="notes-body">
                        <div fxFlex>
                          <textarea
                            placeholder="View owner notes history"
                            (blur)="showConfirmCurrentOwner = false"
                            (focus)="showConfirmCurrentOwner = true"
                            spellcheck="false"
                            [formControl]="currentOwner"
                            [value]="currentOwner.value"
                            readOnly="true"
                            class="notes-body-input custom-scroll-bar"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="end center" class="mm-mt-2">
                    <button
                      mat-flat-button
                      color="primary"
                      (click)="
                        showAddNoteDialog('owner', serviceScript.orderData.currentOwner)
                      "
                    >
                      Add Owner Note
                    </button>
                  </div>
                </div>
                } @if (admin === '1') {
                <div class="pharmacy-instructions mm-mt-3">
                  <div
                    fxLayout="column"
                    fxLayoutAlign="start center"
                    class="inner"
                    [ngClass]="{ editing: showConfirmAdminNotes }"
                  >
                    <div class="notes-inner-container" fxLayout="column">
                      <div class="notes-header">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                          <div fxLayout="column">
                            <span>Admin Notes</span>
                            <span style="font-size: 12px">Admin notes history</span>
                          </div>
                          @if (showConfirmAdminNotes == true) {
                          <div>
                            <button
                              class="confirm-note-button mm-ml-2"
                              (mousedown)="cancelUpdateOrderNotes('adminNotes')"
                            >
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                          }
                        </div>
                      </div>
                      <div class="notes-body">
                        <div fxFlex>
                          <textarea
                            placeholder="View admin notes history"
                            (blur)="showConfirmAdminNotes = false"
                            (focus)="showConfirmAdminNotes = true"
                            spellcheck="false"
                            [formControl]="adminNotes"
                            [value]="adminNotes.value"
                            readOnly="true"
                            class="notes-body-input custom-scroll-bar"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="end center" class="mm-mt-2">
                    <button
                      mat-flat-button
                      color="primary"
                      (click)="
                        showAddNoteDialog('admin', serviceScript.orderData.medmateOrderNotes)
                      "
                    >
                      Add Admin Note
                    </button>
                  </div>
                </div>
                } @if (!isDriverUser && !jwtAuth.isClinician()) {
                <div class="pharmacy-instructions mm-mt-3">
                  <div
                    fxLayout="column"
                    fxLayoutAlign="start center"
                    class="inner"
                    [ngClass]="{ editing: showConfirmPharmacyNotes }"
                  >
                    <div class="notes-inner-container" fxLayout="column">
                      <div class="notes-header">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                          <div fxLayout="column">
                            <span>Pharmacy Notes</span>
                            <span style="font-size: 12px"
                              >Use this area to interact with the support team.</span
                            >
                          </div>
                          @if (showConfirmPharmacyNotes == true) {
                          <div>
                            <button
                              class="confirm-note-button mm-ml-2"
                              (mousedown)="cancelUpdateOrderNotes('pharmacyOrderNotes')"
                            >
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                          }
                        </div>
                      </div>
                      <div class="notes-body">
                        <div fxFlex>
                          <textarea
                            placeholder="View pharmacy notes history"
                            (blur)="showConfirmPharmacyNotes = false"
                            (focus)="showConfirmPharmacyNotes = true"
                            spellcheck="false"
                            [formControl]="pharmacyOrderNotes"
                            [value]="pharmacyOrderNotes.value"
                            readOnly="true"
                            class="notes-body-input custom-scroll-bar"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="end center" class="mm-mt-2">
                    <button
                      mat-flat-button
                      color="primary"
                      (click)="
                        showAddNoteDialog(
                          'pharmacy',
                          serviceScript.orderData.pharmacyOrderNotes
                        )
                      "
                    >
                      Add Pharmacy Note
                    </button>
                  </div>
                </div>
                } @if (dataOrder.isClinicianNotesVisible(serviceScript.orderData?.orderstatus))
                {
                <div class="pharmacy-instructions mm-mt-3">
                  <div
                    fxLayout="column"
                    fxLayoutAlign="start center"
                    class="inner"
                    [ngClass]="{ editing: showConfirmClinicianNotes }"
                  >
                    <div class="notes-inner-container" fxLayout="column">
                      <div class="notes-header">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                          <div fxLayout="column">
                            <span>Clinician Notes</span>
                            <span style="font-size: 12px"
                              >Support team notes for clinician updates</span
                            >
                          </div>
                          @if (showConfirmClinicianNotes == true) {
                          <div>
                            <button
                              class="confirm-note-button mm-ml-2"
                              (mousedown)="cancelUpdateOrderNotes('clinicianNotes')"
                            >
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                          }
                        </div>
                      </div>
                      <div class="notes-body">
                        <div fxFlex>
                          <textarea
                            placeholder="View clinician notes history"
                            (blur)="showConfirmClinicianNotes = false"
                            (focus)="showConfirmClinicianNotes = true"
                            spellcheck="false"
                            [formControl]="clinicianNotes"
                            [value]="clinicianNotes.value"
                            readOnly="true"
                            class="notes-body-input custom-scroll-bar"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if
                  (!dataOrder.isClinicianNotesReadOnly(serviceScript.orderData?.orderstatus)) {
                  <div fxLayout="row" fxLayoutAlign="end center" class="mm-mt-2">
                    <button
                      mat-flat-button
                      color="primary"
                      id="add-note-btn"
                      (click)="
                        showAddNoteDialog('clinician', serviceScript.orderData.clinician_notes)
                      "
                    >
                      {{ jwtAuth.isClinician() ? 'Add Note' : 'Add Clinician Note' }}
                    </button>
                  </div>
                  }
                </div>
                }
              </div>
            </mat-card>
            @if (serviceScript?.originalscriptslist.length>0) {
            <mat-card appearance="outlined" fxLayoutAlign="end end">
              <a routerLink="./" class="mm-text-accent mr-0 mm-link" (click)="openDialog()"
                >Show Order Revision</a
              >
            </mat-card>
            } @if (scripts.length>0) {
            <mat-card appearance="outlined">
              <h3 #itemEditTable>Scripts</h3>
              <table mat-table [dataSource]="scripts" class="mat-elevation-z1 items-table">
                <ng-container matColumnDef="Image">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <div class="tooltip">
                      @if (element.prescriptiontype == 3) {
                      <img
                        src="assets/images/prescription.svg"
                        alt="Prescription icon"
                        style="height: 40px; width: 40px"
                      />
                      } @else {
                      <img
                        (click)="getUID('EAN', element.EAN)"
                        src="assets/images/qrcode.png"
                        style="height: 40px; width: 40px"
                      />
                      }
                      <span class="tooltiptext">Copy EAN</span>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="ItemDetails">
                  <th mat-header-cell *matHeaderCellDef>Script Details</th>
                  <td
                    mat-cell
                    *matCellDef="let element; let i = index"
                    (click)="$event.stopPropagation()"
                  >
                    @if (editshow==1 && !isTelehealthOrder() &&
                    !isInStore(element.payment_status)) {
                    <div>
                      <input class="mm-text-input" [(ngModel)]="scripts[i].drugname" />
                    </div>
                    } @if (editshow==0 || isTelehealthOrder() ||
                    isInStore(element.payment_status)) {
                    <div>
                      <div>{{ element.drugname }}</div>
                      @if (getEntitlement(element.cardtype)) {
                      <div class="mm-badge mm-mb-3 mm-b-2">
                        {{ getEntitlement(element.cardtype) }}
                      </div>
                      }
                      @if (getGenericBrandMark(element); as mark) {
                      <div class="mm-badge mm-mb-3 mm-bg-primary">
                        {{ mark }}
                      </div>
                      }
                    </div>
                    }
                    <div>
                      <a
                        class="mm-text-accent mr-10 mm-link"
                        (click)="viewScript(element)"
                        ngxPrint
                        >View Script</a
                      >
                      @if (serviceScript?.orderData?.medviewFlowStoreID) {
                      <span class="mm-text-accent mr-10 mm-link" (click)="Dispense(element)"
                        >Send&nbsp;to&nbsp;MedView&nbsp;Flow</span
                      >
                      }
                      <span
                        class="mm-text-accent mr-10 mm-link"
                        (click)="printEScript(element.script_url)"
                        >Print</span
                      >
                      @if (element?.selected_variants.length) {
                      <span
                        class="mm-text-accent mr-10 mm-link"
                        (click)="
                          open_variants_dialog(
                            element.variants_type,
                            element.selected_variants
                          )
                        "
                        >{{ element.variants_type }}</span
                      >
                      }
                    </div>
                  </td>
                </ng-container>
                <!-- <ng-container matColumnDef="UnitPrice">
                      <th mat-header-cell *matHeaderCellDef> Unit Price </th>
                      <td mat-cell *matCellDef="let element; let i=index;">
                        <div *ngIf="editshow==1">
                          <input class="mm-text-input" style="width:80px"
                            [(ngModel)]="scripts[i].originalprice">
                          </div>
                          <div *ngIf="editshow==0">
                            {{element.originalprice | currency}}
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="QTY">
                        <th mat-header-cell *matHeaderCellDef> QTY </th>
                        <td mat-cell *matCellDef="let element">
                          {{element.drugpack?element.drugpack:'1'}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="Amount">
                        <th mat-header-cell *matHeaderCellDef> Price </th>
                        <td mat-cell *matCellDef="let element"> {{getTotalPrice(element) | currency }} </td>
                      </ng-container> -->
                <ng-container matColumnDef="PharmacyUnitPrice">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="markup-amount-hold">
                      <span>My Unit Price</span>
                      <mat-icon
                        class="mm-text-primary my-price-info-icon"
                        style="cursor: pointer"
                        (click)="openMyPriceDialog()"
                        >info</mat-icon
                      >
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    @if (!isInStore(element.payment_status)) {
                    <input
                      [disabled]="uberOrder"
                      class="mm-text-input"
                      type="number"
                      min="0"
                      style="width: 80px"
                      [(ngModel)]="element.pharmacyUnitPrice"
                    />
                    } @if (isInStore(element.payment_status)) {
                    <div>{{ element.pharmacyUnitPrice | currency }}</div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="UnitPrice">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="markup-amount-hold">
                      <span>Customer Price</span>
                      <mat-icon
                        class="mm-text-primary my-price-info-icon"
                        style="cursor: pointer"
                        (click)="openMarkupDialog()"
                        >info</mat-icon
                      >
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div>{{ element.originalprice | currency }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="QTY">
                  <th mat-header-cell *matHeaderCellDef>QTY</th>
                  <td mat-cell *matCellDef="let element">
                    <div>{{ element.drugpack ? element.drugpack : '1' }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Amount">
                  <th mat-header-cell *matHeaderCellDef>Amount</th>
                  <td mat-cell *matCellDef="let element">
                    {{ calculateTotalPrice(element) | currency }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="Action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element" class="action-row">
                    @if (!isTelehealthOrder() && !isInStore(element.payment_status)) {
                    <button
                      [disabled]="scripts.length == 1 && items.length == 0"
                      (click)="deleteScript(element.orderbasketid)"
                      mat-icon-button
                    >
                      <mat-icon
                        [ngStyle]="{
                          color: scripts.length == 1 && items.length == 0 ? 'gray' : '#0a2756'
                        }"
                        >delete</mat-icon
                      >
                    </button>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="scriptColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: scriptColumns"></tr>
              </table>
            </mat-card>
            } @if (items.length>0 && !isDriverUser) {
            <mat-card appearance="outlined">
              <h3 #itemEditTable>Items</h3>
              <table mat-table [dataSource]="items" class="mat-elevation-z1 items-table">
                <ng-container matColumnDef="Image">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <div class="tooltip">
                      <img
                        (click)="getUID('EAN', element.EAN)"
                        src="{{ element.itemimage }}"
                        style="height: 40px; width: 40px"
                      />
                      <span class="tooltiptext">Copy EAN</span>
                    </div>
                    <!-- <img (click)='getUID(element.)' src="{{element.itemimage}}" style="height: 40px;width: 40px;" /> -->
                  </td>
                </ng-container>
                <ng-container matColumnDef="ItemDetails">
                  <th mat-header-cell *matHeaderCellDef>Item Details</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    @if (editshow==1&&!uberOrder&&!isTelehealthOrder() &&
                    !isInStore(element.payment_status)) {
                    <div class="table-cell-value">
                      <input class="mm-text-input" [(ngModel)]="items[i].drugname" />
                    </div>
                    }
                    <!-- <div *ngIf="editshow==1 && serviceScript.orderData.deliverypartnername!='Uber Eats'" class="table-cell-value">{{element.drugname}}</div> -->
                    @if
                    (editshow==0||(editshow==1&&uberOrder)||(editshow==1&&!uberOrder&&isTelehealthOrder())
                    || isInStore(element.payment_status)) {
                    <div class="table-cell-value">{{ element.drugname }}</div>
                    }
                    <div>
                      @if (gen_cert_allow(element)) {
                      <span
                        class="mm-text-accent mr-10 mm-link"
                        (click)="open_med_cert_dialog(element)"
                        >Generate&nbsp;Medical&nbsp;Certificate</span
                      >
                      } @if (element.cert_link) {
                      <span
                        class="mm-text-accent mr-10 mm-link"
                        (click)="view_cert(element.cert_link)"
                        >View&nbsp;Certificate</span
                      >
                      }
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="PharmacyUnitPrice">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="markup-amount-hold">
                      <span>My Unit Price</span>
                      <mat-icon
                        class="mm-text-primary my-price-info-icon"
                        style="cursor: pointer"
                        (click)="openMyPriceDialog()"
                        >info</mat-icon
                      >
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    @if (!isTelehealthOrder() && !isInStore(element.payment_status)) {
                    <input
                      [disabled]="uberOrder"
                      class="mm-text-input"
                      type="number"
                      min="0"
                      style="width: 80px"
                      [(ngModel)]="element.pharmacyUnitPrice"
                    />
                    } @if (isTelehealthOrder() || isInStore(element.payment_status)) {
                    <div>
                      {{ element.pharmacyUnitPrice | currency }}
                    </div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="UnitPrice">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="markup-amount-hold">
                      <span>Customer Price</span>
                      <mat-icon
                        class="mm-text-primary my-price-info-icon"
                        style="cursor: pointer"
                        (click)="openMarkupDialog()"
                        >info</mat-icon
                      >
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div>{{ calculateCustomerPrice(element) | currency }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="QTY">
                  <th mat-header-cell *matHeaderCellDef>QTY</th>
                  <td mat-cell *matCellDef="let element">
                    @if (!isTelehealthOrder() && !isInStore(element.payment_status)) {
                    <div>
                      @if (editshow==1) {
                      <button
                        [disabled]="
                          element.drugpack == 1 ||
                          element.drugpack == '' ||
                          element.drugpack === null
                        "
                        color="primary"
                        (click)="
                          onItemDataChangeQty(element.orderbasketid, '-');
                          addToItemsEdited(element)
                        "
                        mat-icon-button
                      >
                        <mat-icon>remove_circle</mat-icon>
                      </button>
                      }
                      {{ element.drugpack ? element.drugpack : '1' }}
                      @if (editshow==1) {
                      <button
                        [disabled]="uberOrder"
                        color="primary"
                        (click)="
                          onItemDataChangeQty(element.orderbasketid, '+');
                          addToItemsEdited1(element)
                        "
                        mat-icon-button
                      >
                        <mat-icon>add_circle</mat-icon>
                      </button>
                      }
                    </div>
                    } @if (isTelehealthOrder() || isInStore(element.payment_status)) {
                    <div>
                      {{ element.drugpack ? element.drugpack : '1' }}
                    </div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="Amount">
                  <th mat-header-cell *matHeaderCellDef>Amount</th>
                  <td mat-cell *matCellDef="let element">
                    {{ calculateTotalPrice(element) | currency }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="Action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element" class="action-row">
                    @if (!isTelehealthOrder() && !isInStore(element.payment_status)) {
                    <button
                      [disabled]="items.length === 1 && scripts.length === 0"
                      color="primary"
                      (click)="deleteItem(element.orderbasketid); addToItemsEdited(element)"
                      mat-icon-button
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </mat-card>
            } @if (!isTelehealthOrder()) {
            <mat-card appearance="outlined" class="mm-pt-0 mm-mt-0">
              @if (editshow === 1 && !uberOrder) {
              <div (click)="addItems = 1" class="outline" style="margin-top: 20px">
                @if (addItems !== 1) {
                <button mat-icon-button>
                  <mat-icon [ngStyle]="{ color: 'lightgray', 'font-size': '40px' }"
                    >add</mat-icon
                  >
                </button>
                } @if (addItems === 1) {
                <div>
                  <input
                    matInput
                    #otcSearchInput
                    value="{{ searchWord }}"
                    [matAutocomplete]="otcItems"
                    [formControl]="otcItemSearch"
                    class="item-search-input"
                    placeholder="Search Items..."
                  />
                  <mat-autocomplete
                    [autoActiveFirstOption]="true"
                    (optionSelected)="onClickAddItem($event)"
                    #otcItems="matAutocomplete"
                    class="custom-scroll-bar"
                  >
                    @if (searchingItem) {
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    }
                    <mat-option [value]="otcItemSearch.value"
                      ><span>Add New Item</span> ({{ otcItemSearch.value }})</mat-option
                    >
                    @for (state of filteredOtcItemResults | async; track state) {
                    <mat-option [value]="state">
                      <img
                        class="example-option-img"
                        aria-hidden
                        [src]="state.PhotoID_s3"
                        height="25"
                      />
                      <span>{{ state.drug }}</span> |
                      <small>Price: {{ state.price }}</small>
                    </mat-option>
                    }
                  </mat-autocomplete>
                </div>
                }
              </div>
              }
            </mat-card>
            } @if (jwtAuth.isClinician()) {
            <app-order-additional-info
              [forms]="submittedDataForms"
              [clinicianNotesRaw]="serviceScript?.orderData?.clinician_notes"
              [canRequestMoreInfo]="canRequestMoreInfoFromPatient()"
              (requestMoreInfo)="requestMoreInfoFromPatient()"
            >
            </app-order-additional-info>
            } @if (canShowDocuments()) {
            <app-order-documents
              #orderDocumentsComponent
              [orderId]="serviceScript.orderData.orderid"
              [userId]="serviceScript.orderData.enduserid"
              [uniqueOrderId]="serviceScript.orderData.uniqueorderid"
              [email]="serviceScript.orderData.emailaddress"
              (medicalCertificateExists)="onMedicalCertificateCheck($event)"
              (documentsLoaded)="onDocumentsLoaded($event)"
              [config]="orderDocumentsConfig"
            ></app-order-documents>
            } @if (!(jwtAuth.isDriver() && jwtAuth.isClinician())) {
            <mat-card appearance="outlined">
              <div fxLayout="row" fxLayoutAlign="end start">
                <div fxFlex="20">
                  @if (!jwtAuth.isClinician()) {
                  <div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                      <div style="font-weight: 600">Sub Total</div>
                      <div>${{ calculateSubTotal() }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start" class="mm-mt-3">
                      <div style="font-weight: 600">Delivery Fee</div>
                      @if (editshow === 1 && admin === '1') {
                      <input
                        [disabled]="uberOrder"
                        type="number"
                        min="0"
                        class="mm-text-input fee-edit-input"
                        [(ngModel)]="newDeliveryFee"
                      />
                      } @else {
                      <div>${{ serviceScript.orderData.deliveryfee || '0.00' }}</div>
                      }
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start" class="mm-mt-3">
                      <div style="font-weight: 600">Service Fee</div>
                      @if (editshow === 1 && admin === '1') {
                      <input
                        [disabled]="uberOrder"
                        type="number"
                        min="0"
                        class="mm-text-input fee-edit-input"
                        [(ngModel)]="newServiceFee"
                      />
                      } @else {
                      <div>${{ serviceScript.orderData.customerServiceFee || '0.00' }}</div>
                      }
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start" class="mm-mt-3">
                      <div style="font-weight: 600">Order Total</div>
                      <div>${{ calculateOrderTotal() }}</div>
                      <!-- <div>${{ newOrderTotal==''?serviceScript.orderData.orderTotal: newOrderTotal }}</div> -->
                    </div>
                    @if (serviceScript?.orderData.orderBalance &&
                    serviceScript?.orderData.orderBalance > 0) {
                    <div>
                      <div fxLayout="row" fxLayoutAlign="space-between start" class="mm-mt-3">
                        <div style="font-weight: 600">Paid</div>
                        <div>${{ serviceScript.orderData.orderPaidAmount }}</div>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="space-between start" class="mm-mt-3">
                        <div style="font-weight: 600">Redemption Amount</div>
                        <div>${{ serviceScript.orderData.redemption_amount || '0.00' }}</div>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="end">---------------</div>
                      <div fxLayout="row" fxLayoutAlign="space-between start" class="mm-mt-3">
                        <div style="font-weight: 600" class="mm-text-pink">Balance Owing</div>
                        <div class="mm-text-pink">
                          ${{ serviceScript.orderData.orderBalance }}
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                  }
                </div>
              </div>
            </mat-card>
            }
            <div>
              @if (editshow == 1 && (items.length || scripts.length)) {
              <mat-card appearance="outlined" fxLayout="row" fxLayoutAlign="end center">
                <div fxLayout="row" fxLayoutAlign="end center">
                  <button
                    mat-flat-button
                    class="mm-bg-orange mm-text-white"
                    (click)="openStockInfoDialog()"
                  >
                    Save
                  </button>
                  <button
                    mat-flat-button
                    class="mm-bg-grey-blue mm-text-white"
                    (click)="cancelItem()"
                    style="margin-left: 6px"
                  >
                    Cancel
                  </button>
                </div>
              </mat-card>
              }
            </div>
          </div>
        </mat-card>
      </div>
    </mat-tab>
    @if (jwtAuth.isAdmin()) {
    <mat-tab label="Version History">
      <app-order-version-history
        [versionHistoryData]="versionHistoryData"
      ></app-order-version-history>
    </mat-tab>
    } @if (serviceScript?.consult_history?.length > 0 && jwtAuth.isAdmin()) {
    <mat-tab label="Consult History">
      <div class="example-large-box mat-elevation-z4" style="margin-top: 20px">
        <table
          class="table-class consult-history-table"
          mat-table
          [dataSource]="consultHistoryDataSource"
          matSort
        >
          <ng-container matColumnDef="date_time">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Time</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ element.date_time | convertToLocalTime }}
            </td>
          </ng-container>
          <ng-container matColumnDef="clinician_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Clinician Name</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ element.clinician_name }}
            </td>
          </ng-container>
          <ng-container matColumnDef="start_time">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Time</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ element.start_time | convertToLocalTime }}
            </td>
          </ng-container>
          <ng-container matColumnDef="end_time">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>End Time</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ element.end_time | convertToLocalTime }}
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Consult Status</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              <span
                class="consult-status"
                [style.background-color]="getConsultStatusColor(element.status)"
              >
                {{ formatConsultStatus(element.status) }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="consult_outcome">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Consult Outcome</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ element.consult_outcome || 'N/A' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="time_spent">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Time Spent</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ formatTimeSpent(element.time_spent, element.start_time, element.end_time) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="number_of_pauses">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Pause Count</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ element.number_of_pauses || '0' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Reason</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ element.reason || 'N/A' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="added_by">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ element.added_by || 'N/A' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="updated_by">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated By</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              {{ element.updated_by || 'N/A' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="consultHistoryColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: consultHistoryColumns"
            class="consult-history-row"
          ></tr>
        </table>
      </div>
    </mat-tab>
    } @if (!isDriverUser && !jwtAuth.isClinician()) {
    <mat-tab label="Customer Profile">
      <ng-template matTabContent>
        <app-user-profile [userId]="serviceScript.orderData.enduserid"></app-user-profile>
      </ng-template>
    </mat-tab>
    } @if (!isDriverUser && !jwtAuth.isClinician()) {
    <mat-tab label="Customer Order History">
      <div class="example-large-box mat-elevation-z4" style="margin-top: 20px">
        <table class="table-class orders-table" mat-table [dataSource]="orderHistory" matSort>
          <ng-container matColumnDef="createddate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              <span class="mobile-label"></span>
              {{ element.created_at | date : 'dd/MM/yyyy h:mm:ss a' }}
              <!-- PH NAME -->
              @if (element.locationname==serviceScript.orderData.locationname) {
              <div class="mt-2">
                {{ element.locationname }}
              </div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="orderid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Unique Order ID</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              <span class="mobile-label"></span>
              {{ element.uniqueorderid }}
            </td>
          </ng-container>
          <ng-container matColumnDef="totalStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              <span class="mobile-label"></span> {{ element.orderTotal | currency }}
              @if (!jwtAuth.isTelehealthPharmacyUser()) {
              <p
                id="payment-info"
                [ngStyle]="{
                  color:
                    element.paymentstatus === '1'
                      ? '#7fe97f'
                      : element.paymentstatus === '0'
                      ? '#ff3d57'
                      : 'black'
                }"
              >
                {{ paymentStatuses[element.paymentstatus] }}
              </p>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="ordertype">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label"></span>{{ element.deliverypartnername }}
            </td>
          </ng-container>
          <ng-container matColumnDef="orderstatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <span class="mobile-label"></span>
              <span
                [ngStyle]="{ color: element.orderStatus === 'New' ? '#0081ff' : '#ff8a48' }"
                >{{
                  element.orderstatus ==
                  'Waiting
                                For Review'
                    ? 'Quote Request'
                    : element.orderstatus == 'Awaiting Authorisation'
                    ? 'Awaiting
                      Payment'
                    : getOrderStatusLabel(element.orderstatus)
                }}</span
              >
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td
              mat-cell
              *matCellDef="let element"
              (click)="$event.stopPropagation()"
              class="action-row"
            >
              <span class="mobile-label"></span>
              @if (admin=="1"||element.locationname ==
              this.serviceScript.orderData.locationname) {
              <button mat-icon-button>
                <mat-icon class="mm-text-accent" (click)="goToOrder(element.orderid)"
                  >launch</mat-icon
                >
              </button>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns1"
            (click)="viewOrder(row.orderid)"
          ></tr>
        </table>
        <mat-paginator
          [pageSizeOptions]="[10, 20, 30, 40]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </mat-tab>
    } @if (serviceScript?.data_forms?.length > 0 && !jwtAuth.isClinician()) {
    <mat-tab label="Patient Submissions">
      <div class="example-large-box mat-elevation-z4" style="margin-top: 20px">
        <table class="table-class orders-table" mat-table [dataSource]="dataFormsDataSource">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Form ID</th>
            <td mat-cell *matCellDef="let element">#{{ element.id }}</td>
          </ng-container>
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">{{ element.title || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="requested_by">
            <th mat-header-cell *matHeaderCellDef>Requested By</th>
            <td mat-cell *matCellDef="let element">
              {{ getDataFormRequestedBy(element.requested_by) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
              <span class="df-status-badge" [ngClass]="'df-status-badge--' + element.status">
                {{ element.status | titlecase }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="submitted_at">
            <th mat-header-cell *matHeaderCellDef>Submitted At</th>
            <td mat-cell *matCellDef="let element">
              {{
                element.submitted_at
                  ? (element.submitted_at | convertToLocalTime : 'DD/MM/YYYY h:mm A')
                  : '—'
              }}
            </td>
          </ng-container>
          <ng-container matColumnDef="expires_at">
            <th mat-header-cell *matHeaderCellDef>Expires At</th>
            <td mat-cell *matCellDef="let element">
              {{
                element.expires_at
                  ? (element.expires_at | convertToLocalTime : 'DD/MM/YYYY h:mm A')
                  : '—'
              }}
            </td>
          </ng-container>
          <ng-container matColumnDef="questions_count">
            <th mat-header-cell *matHeaderCellDef>Questions</th>
            <td mat-cell *matCellDef="let element">{{ element.questions?.length || 0 }}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
              <button
                mat-icon-button
                matTooltip="View form"
                (click)="openDataFormModal(element)"
              >
                <mat-icon class="mm-text-accent">visibility</mat-icon>
              </button>
              @if (element.form_link) {
              <a
                [href]="element.form_link"
                target="_blank"
                rel="noopener noreferrer"
                mat-icon-button
                matTooltip="Open form link"
              >
                <mat-icon class="mm-text-accent">open_in_new</mat-icon>
              </a>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="dataFormsColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: dataFormsColumns"></tr>
        </table>
      </div>
    </mat-tab>
    }
  </mat-tab-group>
</mat-card>
} @if (loading) {
<mat-spinner diameter="50"></mat-spinner>
}

<!-- Floating AI Chatbot Button -->
@if (showTreatmentGuideChatbot) {
<button
  class="floating-ai-button"
  mat-flat-button
  color="primary"
  (click)="openTreatmentGuideChatbot()"
>
  <mat-icon>smart_toy</mat-icon>
  <span class="floating-ai-label">Treatment Guide AI</span>
</button>
}
